module.exports = __webpack_public_path__ + "static/media/section-guide.3acf3608.png";